import React, { useEffect, useRef, useState } from 'react'

function CountryList({ isListOpen, ref, countryArray, onClick, setOpen }) {

    let [searchIndex, setSearchIndex] = useState(null)
    let serarchBoxref = useRef()
    let countryListRef = useRef()

    useEffect(() => {
        serarchBoxref.current.focus()
    }, [])



    let handleSearch = (e) => {

        setSearchIndex(e.target.value)
    }

    const handleClickOutside = (event) => {
        if (countryListRef.current && !countryListRef.current.contains(event.target)) {
            setOpen(false)
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);




    return (
        <div ref={countryListRef} onClick={(e) => { e.stopPropagation() }} className={`country-list ${isListOpen ? "country-list-open" : "country-list-close"}`}>

            <div className="country-search-box-container">
                <input ref={serarchBoxref} value={searchIndex} onChange={handleSearch} className='country-search-box' type="text" name="" id="" />
            </div>


            <div className="country-list-scroller">
                <ul ref={ref}>

                    {
                        countryArray.length > 0 ?
                            countryArray.map((eachCountry, key) => {

                                if (searchIndex && eachCountry) {
                                    if (eachCountry.name.toLowerCase().includes(searchIndex.toLowerCase())) {
                                        return (
                                            <li onClick={(e) => { onClick(e, eachCountry) }} key={key}>{`${eachCountry.name}  ${eachCountry.dial_code}`}</li>
                                        )
                                    }
                                }
                                else {
                                    return (
                                        <li onClick={(e) => { onClick(e, eachCountry) }} key={key}>{`${eachCountry.name}  ${eachCountry.dial_code}`}</li>
                                    )
                                }


                            }) : null
                    }

                </ul>
            </div>

        </div>
    )
}

export default CountryList